module.exports = __webpack_public_path__ + "static/media/stationary.b754146c.png";